import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "dashboardFontStyle mb-2" }
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("      ")
const _hoisted_5 = {
  type: "button",
  ref: "registerNewBiboButton",
  class: "btn btn-primary er fs-6 px-8 py-4 mb-3",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_register_account_modal_bibo`
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("      ")
const _hoisted_7 = {
  type: "button",
  ref: "registerNewECButton",
  class: "btn btn-success er fs-6 px-8 py-4 mb-3",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_register_account_modal_ec`
}
const _hoisted_8 = {
  type: "button",
  ref: "registerAccountOVIButton",
  class: "btn btn-warning er fs-6 px-8 py-4 mb-3",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_register_account_modal`
}
const _hoisted_9 = {
  type: "button",
  ref: "addAccountOVIButton",
  class: "btn btn-warning er fs-6 px-8 py-4 mb-3 mt-3",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_addovi_account_modal`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SequenceOverview = _resolveComponent("SequenceOverview")
  const _component_AccountDetails = _resolveComponent("AccountDetails")
  const _component_font = _resolveComponent("font")
  const _component_RegisterEndorserModalBibo = _resolveComponent("RegisterEndorserModalBibo")
  const _component_RegisterAccountModalEC = _resolveComponent("RegisterAccountModalEC")
  const _component_RegisterModal = _resolveComponent("RegisterModal")
  const _component_SealProEncode = _resolveComponent("SealProEncode")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_SequenceOverview, { currencySymbol: _ctx.currency }, null, 8, ["currencySymbol"]),
    _createVNode(_component_AccountDetails),
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("p", _hoisted_2, [
        _createTextVNode("           Your " + _toDisplayString(_ctx.r2meLinkLabel) + " link is ", 1),
        _createVNode("a", {
          href: _ctx.r2meLink,
          target: "_blank",
          class: "dashboardFontStyle mb-0"
        }, [
          _createVNode(_component_font, { color: "red" }, {
            default: _withCtx(() => [
              _createVNode("b", null, [
                _createVNode("u", null, _toDisplayString(_ctx.r2meLink), 1)
              ])
            ]),
            _: 1
          })
        ], 8, ["href"])
      ], 512), [
        [_vShow, _ctx.isShowR2MELink]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("button", {
        type: "button",
        class: "btn btn-seq-blue px-2 py-2 mb-3",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.registerNewEndorser())),
        style: {"width":"30% !important"}
      }, " Encode BIBO Endorser "),
      _hoisted_4,
      _withDirectives(_createVNode("button", _hoisted_5, " Encode BIBO Endorser ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_RegisterEndorserModalBibo, {
        key: _ctx.modalkey,
        slotdata: _ctx.slotdata
      }, null, 8, ["slotdata"]),
      _createVNode("button", {
        type: "button",
        class: "btn btn-success px-2 py-2 mb-3",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.registerNewECED())),
        style: {"width":"30% !important"}
      }, " Register EC/ED "),
      _hoisted_6,
      _withDirectives(_createVNode("button", _hoisted_7, " Register EC/ED ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_RegisterAccountModalEC, {
        key: _ctx.modalkey,
        slotdata: _ctx.slotdata
      }, null, 8, ["slotdata"]),
      _createVNode("button", {
        type: "button",
        class: "btn btn-primary px-2 py-2 mb-3",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.registerNewOVI())),
        style: {"width":"30% !important"}
      }, " Register OVI "),
      _withDirectives(_createVNode("button", _hoisted_8, " Register OVI ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_RegisterModal, {
        key: _ctx.modalkey,
        slotdata: _ctx.slotdata
      }, null, 8, ["slotdata"]),
      _createVNode("button", {
        type: "button",
        class: "btn btn-warning px-2 py-2 mb-3",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.upgradeAccount())),
        style: {"width":"30% !important"}
      }, " Upgrade Account "),
      _withDirectives(_createVNode("button", _hoisted_9, " Upgrade Account ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProEncode, {
        key: _ctx.modalkey,
        slotdata: _ctx.slotdata,
        sealpro_encode_modal: 'kt_addovi_account_modal',
        firstCoverage: _ctx.firstCoverage,
        allowClose: true,
        inputActivationDetail: false,
        isAddAccount: true,
        allowChangeName: false
      }, null, 8, ["slotdata", "firstCoverage"])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}